import * as types from './actionTypes'

export const HIDE_MODAL = {
  type: types.HIDE_MODAL
}
